module.exports = __webpack_public_path__ + "static/media/logo-nuvemshop.dc8cf535.svg";